import React from 'react';

type IconProps = React.SVGProps<SVGSVGElement>;

export const FacebookIcon: React.FC<IconProps> = (props) => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" {...props}>
    <path d="M13.5 21v-8.1h2.7l.4-3.2h-3.1V7.7c0-.9.3-1.6 1.6-1.6h1.7V3.2C16.1 3.1 15 3 13.8 3c-2.5 0-4.3 1.5-4.3 4.4v2.3H6.8v3.2h2.7V21h4z" />
  </svg>
);

export const TwitterIcon: React.FC<IconProps> = (props) => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" {...props}>
    <path d="M4 4l7.1 9.3L4.3 20h1.9l6-6.4L17 20h3l-7.4-9.7L19.8 4h-1.9l-5.6 6L7.1 4H4z" />
  </svg>
);

export const LinkedInIcon: React.FC<IconProps> = (props) => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" {...props}>
    <path d="M6.9 8.4H3.6V20h3.3V8.4zM5.3 4a1.9 1.9 0 1 0 0 3.8 1.9 1.9 0 0 0 0-3.8zM20.4 20h-3.3v-6.1c0-1.5-.5-2.5-1.8-2.5-1 0-1.6.7-1.9 1.3-.1.2-.1.6-.1.9V20H10s.1-10.6 0-11.6h3.3v1.6c.4-.7 1.2-1.7 3-1.7 2.2 0 3.9 1.5 3.9 4.6V20z" />
  </svg>
);

export const YoutubeIcon: React.FC<IconProps> = (props) => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" {...props}>
    <path d="M21.6 7.7a2.7 2.7 0 0 0-1.9-1.9C18 5.3 12 5.3 12 5.3s-6 0-7.7.5A2.7 2.7 0 0 0 2.4 7.7 28 28 0 0 0 2 12a28 28 0 0 0 .4 4.3 2.7 2.7 0 0 0 1.9 1.9c1.7.5 7.7.5 7.7.5s6 0 7.7-.5a2.7 2.7 0 0 0 1.9-1.9A28 28 0 0 0 22 12a28 28 0 0 0-.4-4.3zM10 15V9l5.2 3-5.2 3z" />
  </svg>
);
